import { Flex, Spacing } from '@billy/design-system'
import { ReactElement } from 'react'

import { useBankAccountListData } from '@features/bankAccounts/hooks/useBankAccountListData'

import { AccountCardByType } from './elements/AccountCardByType'
import { AccountsBalance } from './elements/AccountsBalance'
import { AccountsBanner } from './elements/AccountsBanner'
import { BankAccountModals } from './elements/BankAccountModals'
import * as Styled from './styles'

interface BankAccountListProps {
  onOpenSandbox: () => void
}

export const BankAccountList = ({ onOpenSandbox }: BankAccountListProps): ReactElement => {
  const {
    activeAccounts,
    bankAccountsByAccountId,
    openBankingAccountsByAccountId,
    totalBalance,
    baseCurrencyId,
    hasOnlyEmptyDefaultBankAccount,
    shouldShowBankUpsell,
  } = useBankAccountListData()

  if (hasOnlyEmptyDefaultBankAccount) {
    return <AccountsBanner withBottomMargin onOpenSandbox={onOpenSandbox} />
  }

  return (
    <>
      <AccountsBalance amount={totalBalance} currency={baseCurrencyId} />
      {activeAccounts?.length === 1 ? (
        <Flex gap={Spacing.S24} alignItems="flex-start">
          <Styled.FixedCard>
            <AccountCardByType
              account={activeAccounts[0]}
              bankAccountsByAccountId={bankAccountsByAccountId}
              openBankingAccountsByAccountId={openBankingAccountsByAccountId}
            />
          </Styled.FixedCard>
          {!shouldShowBankUpsell && <AccountsBanner onOpenSandbox={onOpenSandbox} />}
        </Flex>
      ) : (
        <>
          {!shouldShowBankUpsell && <AccountsBanner withBottomMargin onOpenSandbox={onOpenSandbox} />}
          <Styled.GridContainer>
            {activeAccounts?.map((account) => (
              <AccountCardByType
                key={account.id}
                account={account}
                bankAccountsByAccountId={bankAccountsByAccountId}
                openBankingAccountsByAccountId={openBankingAccountsByAccountId}
              />
            ))}
          </Styled.GridContainer>
        </>
      )}
      <BankAccountModals />
    </>
  )
}
